import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from "uuid";
import {
  getSaleOrderRequest,
  getSaleOrderRequestById,
  getParticularPage,
  getNext,
  getPrevious,
  handleSearch,
  createSaleOrderRequest,
} from "./thunk";
import { NepaliDate } from "@zener/nepali-datepicker-react";
import { dateFormater } from "../../../../../../Utils/dateFormater";
import { materialRequestsFrom } from "../../../../../../Utils/constants";

const initialState = {
  saleOrderRequests: [],
  edit: false,
  saleOrderRequest: null,
  count: 0,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingCreate: false,
  loadingUpdated: false,
  loadingSaleOrderRequest: false,
  loadingNext: false,
  oldSaleOrderRequestDetails: [],
  saleOrderRequestDetails: [
    {
      product: null,
      vendor: null,
      closingStock: "",
      description: "",
      actualQuantity: "",
      unit: "",
      altQuantity: "",
      altUnit: null,
      rate: "",
      amount: "",
      requiredDate: dateFormater(new NepaliDate().toADasDate()),
      unique: uuidv4(),
    },
  ],
  showCreateModal: false,
  formData: {
    indentNo: "",
    isFromHo: materialRequestsFrom[0],

    requiredDateBs: new NepaliDate(),
    voucherDateBs: new NepaliDate(),
    requesterName: "",
    department: null,
    branch: null,
    receiverBranch: null,
    placeOfSupply: "",
    termsOfDelivery: "",
    narration: "",
    discount: "",
    documentsAttach: [],
  },
};

export const saleOrderRequestSlice = createSlice({
  name: "saleOrderRequest",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    saleOrderRequestDetailsUpdated: (state, action) => {
      state.saleOrderRequestDetails = action.payload;
    },

    clearSaleOrderRequestDetails: (state) => {
      state.saleOrderRequestDetails = [
        {
          product: null,
          vendor: null,
          closingStock: "",
          description: "",
          actualQuantity: "",
          unit: "",
          altQuantity: "",
          altUnit: null,
          rate: "",
          amount: "",
          requiredDate: dateFormater(new NepaliDate().toADasDate()),
          unique: uuidv4(),
        },
      ];
    },
    clearAllSaleOrderRequest: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingSaleOrderRequest = false;
      state.saleOrderRequest = null;
      state.oldSaleOrderRequestDetails = [];
      state.saleOrderRequestDetails = [
        {
          product: null,
          vendor: null,
          closingStock: "",
          description: "",
          actualQuantity: "",
          unit: "",
          altQuantity: "",
          altUnit: null,
          rate: "",
          amount: "",
          requiredDate: dateFormater(new NepaliDate().toADasDate()),
          unique: uuidv4(),
        },
      ];
      state.formData = initialState.formData;
    },

    saveSaleOrderRequestForm: (state, action) => {
      state.formData = action.payload;
    },
    resetSaleOrderRequestForm: (state, action) => {
      if (action.payload) {
        state.formData = state.saleOrderRequest;
        state.saleOrderRequestDetails = state.oldSaleOrderRequestDetails;
      } else {
        state.formData = initialState.formData;
        
      }
    },
  },
  extraReducers: (builder) => {
    // getSaleOrderRequestById
    builder.addCase(createSaleOrderRequest.pending, (state) => {
      state.loadingCreate = true;
    });
    builder.addCase(createSaleOrderRequest.fulfilled, (state, action) => {
      state.loadingCreate = false;
    });
    builder.addCase(createSaleOrderRequest.rejected, (state) => {
      state.loadingCreate = false;
    });
    builder.addCase(getSaleOrderRequestById.pending, (state) => {
      state.loading = true;
      state.saleOrderRequest = null;
    });
    builder.addCase(getSaleOrderRequestById.fulfilled, (state, action) => {
      const saleOrderRequest = action.payload.data;

      const transformedFormData = {
        ...saleOrderRequest,
        indentNo: saleOrderRequest.docNumberingData?.sequenceNumber,
        isFromHo:
          materialRequestsFrom?.find((value) => value.id === saleOrderRequest?.purchaseOrderRequest.isFromHo) ||
          materialRequestsFrom[0],

        requiredDateBs: saleOrderRequest?.purchaseOrderRequest?.requiredDateBs || new NepaliDate(),
        voucherDateBs: new NepaliDate(),
        requesterName: saleOrderRequest?.purchaseOrderRequest?.requesterName?.fullName,
        department: saleOrderRequest?.purchaseOrderRequest?.department,
        branch: saleOrderRequest?.purchaseOrderRequest?.branch,
        receiverBranch: saleOrderRequest?.purchaseOrderRequest?.receiverBranch,
        placeOfSupply: saleOrderRequest?.purchaseOrderRequest?.placeOfSupply,
        narration: saleOrderRequest?.purchaseOrderRequest?.narration,
        termsOfDelivery: "",
      };

      const transformedDetails = [
        ...action.payload.data?.saleOrderRequestDetails.map((value) => ({
          ...value,
          unique: uuidv4(),
        })),
        {
          unique: uuidv4(),
          actualQuantity: "",
          altUnit: null,
          altQuantity: "",
          amount: "",
          closingStock: "",
          description: "",
          product: null,
          rate: "",
          requiredDateAd: dateFormater(new NepaliDate().toADasDate()),
          unit: "",
        },
      ];

      state.saleOrderRequest = transformedFormData; // for reset reference
      state.formData = transformedFormData;
      state.oldSaleOrderRequestDetails = transformedDetails;
      state.saleOrderRequestDetails = transformedDetails;
      state.edit = true;
      state.loading = false;
    });

    builder.addCase(getSaleOrderRequestById.rejected, (state) => {
      state.edit = false;
      state.loading = false;
      state.saleOrderRequest = null;
    });
    builder.addMatcher(
      isAnyOf(
        getSaleOrderRequest.pending,
        getParticularPage.pending,
        getPrevious.pending,
        getNext.pending,
        handleSearch.pending
      ),
      (state) => {
        state.loadingSaleOrderRequest = true;
      }
    );

    builder.addMatcher(
      isAnyOf(
        getSaleOrderRequest.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingSaleOrderRequest = false;
        state.saleOrderRequests = action.payload.data;
        state.count = action.payload.totalCount;

        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getSaleOrderRequest.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingSaleOrderRequest = false;
      }
    );
  },
});

export const {
  setShowCreateModal,
  goToPage,
  saleOrderRequestDetailsUpdated,
  clearSaleOrderRequestDetails,
  clearAllSaleOrderRequest,
  saveSaleOrderRequestForm,
  resetSaleOrderRequestForm,
} = saleOrderRequestSlice.actions;

export default saleOrderRequestSlice.reducer;
